import { AutogenModelCustomerFuelOptions, AutogenRowCustomerFuelOptions } from "./autogen/AutogenModelCustomerFuelOptions";

export class ModelCustomerFuelOptions extends AutogenModelCustomerFuelOptions<RowCustomerFuelOptions> {
	constructor() {
		super(RowCustomerFuelOptions);
	}
}

export class RowCustomerFuelOptions extends AutogenRowCustomerFuelOptions {
}